import { z } from "zod/v4";

import { LivePriceDtoSchema } from "../../../dtos/live-prices";
import { StripeProductVersionList } from "../../../schemas/stripe";

export const GetLivePricesResponseBodySchema = z.object({
  prices: LivePriceDtoSchema.array(),
});

export type GetLivePricesResponseBodyType = z.infer<
  typeof GetLivePricesResponseBodySchema
>;

export const GetLivePricesQueryStringParametersSchema = z.object({
  version: z.enum(StripeProductVersionList).optional().default("v3"),
});

export type GetLivePricesRequestQueryStringParamsType = z.infer<
  typeof GetLivePricesQueryStringParametersSchema
>;
